import React, { Suspense } from "react";
import { I18nextProvider } from "react-i18next";
import "./translation";
import i18n from "./translation";

import OtherPage from "./pages/Home";

const App = () => {
  return (
    <>
      <Suspense fallback="loading">
        <I18nextProvider i18n={i18n}>
          <div className="App">
            <OtherPage />
          </div>
        </I18nextProvider>
      </Suspense>
    </>
  );
};

export default App;
